export default __webpack_public_path__ + "static/media/Twitter.12bc4f58.svg";